export enum MppButtonWriteMode {
  RTL = 'rtl',
}
